import { useNavigate } from "react-router-dom"

import { Container } from "../../../components/Container"
import { Section } from "../../../components/Section"
import { Steps } from "../../../components/Steps"
import { StepsContent } from "../../../context/StepsContext"
import { InsuranceInfo } from "../../../containers/InsuranceInfo"
import { Step2Form, Step2FormValues } from '../../../containers/sme/Step2Form'

export const Step2 = () => {
  const navigate = useNavigate()

  const handleSubmit = (values: Step2FormValues) => {
    console.log(values)
    navigate('/sme/wizard/3')
  }

  return (
    <Section>
      <Container>
        <StepsContent sx={{ minH: '3000px' }} step={2}>
          <Steps icon="briefcase" />

          <InsuranceInfo />

          <Step2Form onSubmit={handleSubmit} />
        </StepsContent>
      </Container>
    </Section>
  )
}